import { useGetSharedDrives } from '@bpm-web-app/swr-hooks';
import { convertToPluralIfNeeded, getInitialsFromName, createAppRoutes, useViewport } from '@bpm-web-app/utils';
import { Fragment, useMemo } from 'react';
import classNames from 'classnames';
import CardCreate from '../../shared/card/card-create';
import styles from './my-drive.module.css';
import { PageHeader } from '../../shared/page-header/page-header';

export function MySharedDrives() {
    const { data } = useGetSharedDrives(true);
    const sharedDrives = useMemo(() => data?.data, [data?.data]);
    const { isMobile } = useViewport();

    return (
        <div className={classNames(styles['my-drive'], 'spacing__window',)}>
            <PageHeader
                title={sharedDrives ? `Shared With Me (${sharedDrives.length})` : 'Shared With Me'}
            />
            <div className={classNames(styles['my-drive__grid'], 'spacing--top')}>

                {sharedDrives?.map((item) => (
                    <Fragment key={item.id}>
                        <CardCreate
                            contentType="drive"
                            imageUrl={item.custom_image_url || item.image_url || ''}
                            title={item.name}
                            description={isMobile ? undefined : convertToPluralIfNeeded(item.sound_count, 'Sound')}
                            id={item.id}
                            cardSize="user-playlist"
                            userPlaylistConfig={{
                                initials: getInitialsFromName(item.name),
                                imageBgColor: item?.image_color || '#FFFFFF',
                            }}
                            link={createAppRoutes.myDriveId(item.id)}
                            hideMoreOptions
                        />
                    </Fragment>
                ))}
            </div>
        </div>
    );
}
